import {
  fetchProductsByCompany,
  getTotalCountOfProducts,
} from '@/services/Products/product.services';
import { Product } from '@/types/products.type';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface ProductsState {
  products: Product[];
  loading: boolean;
  error: string | null;
  totalProducts: number;
}

const initialState: ProductsState = {
  products: [],
  loading: false,
  error: null,
  totalProducts: 0,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.products = action.payload.products || [];
      state.totalProducts = action.payload.totalProducts || 0;
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'Error fetching products';
    });
  },
});

export default productsSlice.reducer;

type FetchProductsArgs = {
  companyId: string;
  page: number;
  pageSize: number;
  filters: Record<string, any>;
};
export const fetchProducts = createAsyncThunk(
  'products/fetch',
  async ({ companyId, page, pageSize, filters }: FetchProductsArgs) => {
    try {
      const products = await fetchProductsByCompany(companyId, page, pageSize, filters);
      const totalProducts = await getTotalCountOfProducts(companyId, filters);

      if (products && totalProducts) {
        return { products, totalProducts };
      } else {
        return { products: [], totalProducts: 0 };
      }
    } catch (err) {
      throw new Error('Errors.reports_finances_error');
    }
  },
);
